import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProjectInstalledSurveillanceCameraMaster";
const FetchRequestType = "GAAProjectInstalledSurveillanceCameraFetchRequest";

// Save All Data To Database //
export const SaveGAASurveillanceCameraMaster = async (ref, payload, images) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};
// Get All Data From Database //
export const GetGAASurveillanceCameraMasterList = async () => {
  let payload = {GAAProjectInstalledSurveillanceCameraRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

// Get Single Data From Database //
export const GetGAASurveillanceCameraMaster = async (Ref) => {
  let payload = {GAAProjectInstalledSurveillanceCameraRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteGAASurveillanceCameraMaster = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGAASurveillanceCameraMasterListByProject = async (projectRef) => {
  let payload = { GAAProjectRefs: [projectRef]};
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
  // console.log('result :', result);
};